var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeadactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "hue"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.0835 0H0.84668V35.9211H33.0835V0Z",
    fill: "#EDC14A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeadactive);
export default __webpack_public_path__ + "static/media/dead active.01f274fc8ec16d14939b1e281b122f79.svg";
export { ForwardRef as ReactComponent };